import { useTranslation } from '@frontend/i18n';
import { useCareCreditLocationProviderStatus, useCareCreditLocationStatus } from '@frontend/payments-care-credit';
import { useSelectedLocation } from '@frontend/payments-hooks';
import { ContentLoader } from '@frontend/design-system';
import * as styles from '../styles/payment-settings-page.styles';
import { LocationConnectedSettings } from './care-credit-section/location-connected-settings';
import { LocationNotConnectedSettings } from './care-credit-section/location-not-connected-settings';

export const CareCreditSection = () => {
  const locationId = useSelectedLocation();

  const { t } = useTranslation('payments');

  const { isCareCreditEnabled } = useCareCreditLocationStatus(locationId);

  const { isProviderConnected, isProviderLoading } = useCareCreditLocationProviderStatus(
    { locationId },
    { enabled: isCareCreditEnabled }
  );

  if (!isCareCreditEnabled) {
    return (
      <section css={[styles.form]}>
        <p>{t('CareCredit is not enabled for this location.')}</p>
      </section>
    );
  }
  return (
    <section css={[styles.form]}>
      <ContentLoader show={isProviderLoading} />
      {isProviderConnected && <LocationConnectedSettings locationId={locationId} />}
      {!isProviderConnected && <LocationNotConnectedSettings locationId={locationId} />}
    </section>
  );
};
